<template>
    <div class="o-login">
        <p class="a-title o-login__title">
            Błąd 404. Strona nie istnieje.
            <br /><br />
            <a-button
                class="o-login__button"
                type="fullwidth-light"
                @click="authStatus === 'loggedOut' ? $router.push({ name: 'login' }) : $router.push({ name: 'dashboard' })"
                :process-on-click="true"
            >
                Idź do strony {{ authStatus === 'loggedOut' ? 'logowania' : 'głównej' }}
            </a-button>
        </p>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Błąd 404'
    },
    computed: {
        authStatus() {
            return this.$store.getters.authStatus
        }
    }
}
</script>